// extracted by mini-css-extract-plugin
module.exports = {"container":"unsubscribe-playlist_container__uvRnY","skeleton_animate":"unsubscribe-playlist_skeleton_animate__yQyXS","loading-roller":"unsubscribe-playlist_loading-roller__NwJPK"};